export var scrollToTop = function scrollToTop() {
  var _window;

  (_window = window) === null || _window === void 0 ? void 0 : _window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
};